import clsx from "clsx";
import { FC } from "react";
import { DOTS, UsePagination } from "./usePagination";
import "./pagination.scss"
import { MYSVG } from "../Helpers/MYSVG";

type Props = {
    className: string,
    onPageChange: any,
    totalCount: number | undefined,
    siblingCount: number,
    currentPage: number,
    pageSize: number
}
export const Pagination: FC<Props> = ({
    className,
    onPageChange,
    totalCount,
    siblingCount,
    currentPage,
    pageSize
}) => {

    const paginationRange: any = UsePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    if (currentPage === 0 || paginationRange.length < 2) {
        return null;
    }

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    let lastPage = paginationRange[paginationRange.length - 1];
    return (
        <ul
            className={clsx('pagination-container', { [className]: className })}
        >
            <li
                className={clsx('pagination-item', {
                    disabled: currentPage === 1
                })}
                onClick={onPrevious}
            >
                <MYSVG className="hover:border hover:bg-slate-100" path="/assets/svg/tableLeft.svg" svgClassName="h-6 w-6" />{" "}
            </li>
            {paginationRange.map((pageNumber: any,index:number) => {
                if (pageNumber === DOTS) {
                    return <li key={"range"+index} className="pagination-item dots">&#8230;</li>;
                }

                return (
                    <li
                    key={"page"+index}
                        className={clsx('pagination-item hover:border hover:bg-slate-100 hover:text-blue-500', {
                            selected: pageNumber === currentPage
                        })}
                        onClick={() => onPageChange(pageNumber)}
                    >
                        {pageNumber}
                    </li>
                );
            })}
            <li
                className={clsx('pagination-item', {
                    disabled: currentPage === lastPage
                })}
                onClick={onNext}
            >
                <MYSVG className="hover:border hover:bg-slate-100" path="/assets/svg/tableRigth.svg" svgClassName="h-6 w-6" />{" "}
                
            </li>
        </ul>
    );
};